import * as PropTypes from 'prop-types';
import { allowNull } from '../../helpers/propType.helper';
export var textAreaFieldPropTypes = {
  disabled: PropTypes.bool,
  'data-id': PropTypes.string,
  error: PropTypes.string,
  helpText: PropTypes.string,
  label: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  maxLengthExcludeChars: PropTypes.array,
  maxLengthToDisplay: PropTypes.number,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  renderOverlay: PropTypes.func,
  setInputRef: PropTypes.func,
  showCharacterCount: PropTypes.bool,
  skinType: PropTypes.oneOf(['box', 'standard', 'textArea']),
  spinner: PropTypes.bool,
  touched: allowNull(PropTypes.bool),
  transform: PropTypes.func,
  value: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};